import { ECampaignStatus } from '@domain/enums/dashboard/adsManager/ECampaigns';

export const getCampaignsStatus = (status: boolean): ECampaignStatus => {
  if (status) return ECampaignStatus.ENABLED;

  return ECampaignStatus.PAUSED;
};
